var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('list-page-gen',{attrs:{"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }